<template>
  <div
    class="select-container"
    :class="{ open: isOpen, nobor: border == false }"
    v-on-clickaway="away"
  >
    <div :class="isBillLine ? 'select-input  bill-line' : 'select-input'">
      <span
        class="fa fa-angle-down cross"
        v-if="!isDisabled && keyWord != ''"
        @click="onClear"
      ></span>
      <input
        type="text"
        class="form-control form-control"
        ref="input"
        :placeholder="place"
        v-model="keyWord"
        @focus="onFocus"
        @input="toList"
        :disabled="isDisabled"
      />
    </div>
    <div
      class="select-dropdown vld-parent"
      ref="i100"
      style="min-height: 30px"
      :style="{ width: dropWidth }"
    >
      <table class="table table-sm table-hover table-hand" style="margin-bottom: 0">
        <thead>
          <tr v-if="noAddNew">
            <td colspan="2" class="text-center" @click="select(1, { line_no: line_no })">
              <button type="button" class="btn btn-sm green">
                <i class="fa fa-plus-circle" aria-hidden="true"></i>
                Add New
              </button>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr v-if="is_include_all" @click="select(null)">
            <td colspan="2">{{ $t("all") }}</td>
          </tr>
          <tr v-for="(ret, index) in list" :key="index" @click="select(3, ret)">
            <td>
              {{ ret.Name }}
              <div>{{ ret.NameEn }}</div>
            </td>
            <td>{{ ret.Num }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { mixin as clickaway } from "vue-clickaway";
export default {
  mixins: [clickaway],
  props: {
    value: {
      type: String,
      default: "",
    },
    border: {
      type: Boolean,
      default: true,
    },
    place: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    productType: {
      type: String,
      default: "0",
    },
    isIncludeAll: {
      type: Boolean,
      default: false,
    },
    dropdownWidth: {
      type: String,
      default: "100%",
    },
    vAddNew: {
      type: Boolean,
      default: false,
    },
    vLineNo: {
      type: Number,
      default: 0,
    },
    isBillLine: {
      type: Boolean,
      default: true,
    }
  },
  data: function () {
    return {
      keyWord: this.value,
      productTypeId: this.productType,
      isOpen: false,
      list: [],
      isDisabled: this.disabled,
      noAddNew: this.vAddNew,
      isShow: false,
      is_include_all: this.isIncludeAll,
      dropWidth: this.dropdownWidth,
      line_no: this.vLineNo,      
    };
  },
  methods: {
    toList() {
      this.list = [];
      let loading = this.$loading.show({
        container: this.$refs.i100,
        height: 25,
        loader: "dots",
      });
      
      const query = {
        CompanyId: this.$store.state.company.Id,
        Text: this.keyWord,
        ProductTypeId: this.productTypeId,
      };
      this.$api()
        .post("item/select", query)
        .then((res) => {
          if (this.$isValid(res)) {
            this.list = res.data.Json.Items;
            this.isShow = true;
          }
        })
        .finally(function () {
          loading.hide();
        });
    },
    onFocus() {
      this.isOpen = true;
      if (!this.isShow) this.toList();
    },
    away() {
      this.isOpen = false;
    },
    select(n, item) {
      if (item == null) {
        this.keyWord = "";
      } else {
        this.keyWord = item.Name;
      }
      this.isOpen = false;
      this.$emit("select", { type: n, data: item });
    },
    onClear() {
      this.keyWord = "";
      this.$refs.input.focus();
      this.toList();
    },
  },
  watch: {
    value(val) {
      this.keyWord = val;
    },
    disabled(value) {
      this.isDisabled = value;
    },
  },
};
</script>
